{
    "advanced": {
        "action_list": "アクションリスト",
        "helpers": "補助ツール",
        "hide": "畳む",
        "loading_workers": "ワーカーを読み込み中",
        "run": "実行",
        "show": "展開",
        "sim_options": "シミュレーター設定",
        "substat_helper": "サブオプション設定ツール",
        "workers_available": "使用可能なワーカー数: "
    },
    "artifact_names": {
        "archaicpetra": "悠久の磐岩",
        "berserker": "狂戦士",
        "blizzardstrayer": "氷風を彷徨う勇士",
        "bloodstainedchivalry": "血染めの騎士道",
        "braveheart": "勇士の心",
        "crimsonwitchofflames": "燃え盛る炎の魔女",
        "defenderswill": "守護の心",
        "emblemofseveredfate": "絶縁の旗印",
        "gambler": "博徒",
        "gladiatorsfinale": "剣闘士のフィナーレ",
        "heartofdepth": "沈淪の心",
        "huskofopulentdreams": "華館夢醒形骸記",
        "instructor": "教官",
        "lavawalker": "烈火を渡る賢者",
        "maidenbeloved": "愛される少女",
        "martialartist": "武人",
        "noblesseoblige": "旧貴族のしつけ",
        "oceanhuedclam": "海染硨磲",
        "paleflame": "蒼白の炎",
        "prayersfordestiny": "水祭りの人",
        "prayersforillumination": "火祭りの人",
        "prayersforwisdom": "雷祭りの人",
        "prayerstospringtime": "氷祭りの人",
        "resolutionofsojourner": "旅人の心",
        "retracingbolide": "逆飛びの流星",
        "scholar": "学者",
        "shimenawasreminiscence": "追憶のしめ縄",
        "tenacityofthemillelith": "千岩牢固",
        "theexile": "亡命者",
        "thunderingfury": "雷のような怒り",
        "thundersoother": "雷を鎮める尊者",
        "tinymiracle": "奇跡",
        "viridescentvenerer": "翠緑の影",
        "wandererstroupe": "大地を流浪する楽団"
    },
    "character": {
        "artifact_stats": "聖遺物ステータス",
        "c_post": "凸",
        "c_pre": "星座",
        "lvl": "レベル",
        "talents": "天賦"
    },
    "characteredit": {
        "add_set_bonus": "セット効果を追加",
        "anemo": "風ダメージ",
        "artifact_stats_main": "聖遺物ステータス (メイン + サブ)",
        "ascension": "突破",
        "atk_atk": "攻撃実数/攻撃%",
        "attack": "通常攻撃",
        "burst": "元素爆発",
        "cd": "会心ダメージ",
        "change": "変更",
        "character": "キャラクター",
        "cons": "星座",
        "cr": "会心率",
        "cryo": "氷ダメージ",
        "def_def": "防御力/防御力%",
        "electro": "雷ダメージ",
        "em": "元素熟知",
        "er": "元素チャージ効率",
        "geo": "岩ダメージ",
        "heal": "治癒効果バフ",
        "hp_hp": "HP実数/HP%",
        "hydro": "水元素ダメージ",
        "level": "レベル",
        "phy": "物理ダメージ",
        "pyro": "炎ダメージ",
        "refine": "精錬",
        "set_bonus": "セット効果:",
        "skill": "スキル",
        "weapons_and_artifacts": "武器と聖遺物"
    },
    "character_names": {
        "aether": "空",
        "lumine": "蛍",
        "albedo": "アルベド",
        "aloy": "アーロイ",
        "amber": "アンバー",
        "barbara": "バーバラ",
        "beidou": "北斗",
        "bennett": "ベネット",
        "chongyun": "重雲",
        "diluc": "ディルック",
        "diona": "ディオナ",
        "eula": "エウルア",
        "fischl": "フィッシュル",
        "ganyu": "甘雨",
        "hutao": "胡桃",
        "jean": "ジン",
        "kazuha": "楓原万葉",
        "kaeya": "ガイア",
        "ayaka": "神里綾華",
        "keqing": "刻晴",
        "klee": "クレー",
        "sara": "九条裟羅",
        "lisa": "リサ",
        "mona": "モナ",
        "ningguang": "凝光",
        "noelle": "ノエル",
        "qiqi": "七七",
        "raiden": "雷電将軍",
        "razor": "レザー",
        "rosaria": "ロサリア",
        "kokomi": "珊瑚宮心海",
        "sayu": "早柚",
        "sucrose": "スクロース",
        "tartaglia": "タルタリヤ",
        "thoma": "トーマ",
        "venti": "ウェンティ",
        "xiangling": "香菱",
        "xiao": "魈",
        "xingqiu": "行秋",
        "xinyan": "辛炎",
        "yanfei": "煙緋",
        "yoimiya": "宵宮",
        "zhongli": "鍾離",
        "gorou": "ゴロー",
        "itto": "荒瀧一斗",
        "shenhe": "申鶴",
        "yunjin": "雲菫",
        "yaemiko": "八重神子"
    },
    "components": {
        "close": "閉じる",
        "currently_loaded_workers": "現在読み込まれているワーカー数: ",
        "no_characters": "キャラクターがありません",
        "result_post": "ミリ秒 / DPS: ",
        "result_pre": "シミュレーション完了。経過時間: ",
        "running_simulation": "シミュレーション実行中。:",
        "see_results_in": "結果を閲覧モードで確認",
        "set": "設定",
        "simulation_exited_with": "エラー発生によりシミレーションは中断されました: ",
        "workers_post": "でシミュレーションを実行中...",
        "workers_pre": "ワーカー数："
    },
    "dash": {
        "about": "このツールについて",
        "advanced_mode": "詳細モード(上級者向け)",
        "contribute": "協力する",
        "desktop_tool": "デスクトップ版",
        "documentation": "資料",
        "is_a_team": "は原神のための編成DPSシミュレーターです. 以下のボタンから各モードへ移れます!",
        "simulator": "シミュレーター",
        "teams_db": "編成データベース",
        "viewer": "閲覧モード"
    },
    "db": {
        "author": "作成者: ",
        "average_dps_per": "ターゲット1体あたりの平均DPS: ",
        "c_post": "凸",
        "c_pre": "",
        "cancel": "キャンセル",
        "character": "キャラクター",
        "continue": "続ける",
        "description": "説明:",
        "details": "詳細",
        "er": "元素チャージ効率: ",
        "error_loading_database": "データベースを読み込み中にエラーが発生しました: データが存在しません",
        "filters": "絞り込み:",
        "hash": "ハッシュ: ",
        "load_in_simulator": "シミュレーターに読み込み",
        "loading": "読み込み中 ...",
        "number_of_targets": "ターゲット数: ",
        "r": " 精錬",
        "show_in_viewer": "閲覧モードに読み込み",
        "total_dps": "合計DPS: ",
        "type_to_search": "ここに入力して検索...",
        "weapon": "武器"
    },
    "footer": {
        "gcsim_is_not": "このウェブサイトは個人的な計算を目的としており、gcsim, miHoYoとは関係ありません。原神のゲームコンテンツや素材の商標および著作権はmiHoYoに帰属します。 日本語翻訳作成:からしな_（Karashina#8663）"
    },
    "links": {
        "error_loading_database": "データベースを読み込み中にエラーが発生しました: データが存在しません"
    },
    "nav": {
        "about": "このツールについて",
        "advanced": "詳細モード",
        "chinese": "中文",
        "japanese": "日本語",
        "english": "English",
        "spanish": "Español",
        "language": "言語設定:",
        "simulator": "シミュレーター",
        "teams_db": "編成データベース",
        "viewer": "閲覧モード"
    },
    "sim": {
        "loading_simulator_please": "シミュレーター読み込み中。 しばらくお待ちください。"
    },
    "simple": {
        "action_list": "アクションリスト",
        "add_character": "キャラクター追加",
        "discord_post": " に多くの記述例がありますのでご参照ください。",
        "discord_pre": "下のテキストボックスにシミュレーションへ追加したい行動や要素を記述します。何を書けばいいかわからない方は",
        "documentation": "資料",
        "documentation_post": "もありますのでご活用ください。",
        "documentation_pre": "また、連続モード（旧:計算モード）の使い方や使用できる要素をまとめた",
        "done": "完了",
        "exit_edit": "編集を終了する",
        "give_me_back": "チュートリアルを再表示",
        "hide": "隠す",
        "hide_all_tips": "すべてのチュートリアルを隠す",
        "loading_workers": "ワーカーを読み込み中",
        "run": "実行",
        "show": "表示",
        "sim_options": "シミュレーター",
        "start_by_adding": "編成にキャラクターを追加",
        "team": "編成",
        "video": "動画",
        "video_post": "をチェックしてください！",
        "video_pre": "編成にキャラクターを追加して開始しましょう！使い方はこの",
        "workers_available": "使用可能なワーカー数: "
    },
    "src": {
        "this_page_is": "このページはまだ実装されていません。いましばらくお待ちください！"
    },
    "viewer": {
        "ability_usage_count": "能力使用回数 (平均値)",
        "api_key_supporters": "APIキー (支援者限定)",
        "attack": "通常攻撃",
        "average_character_field": "平均出場時間",
        "average_dps_by": "キャラクターごとの平均DPS",
        "avg_dps": "平均DPS",
        "built_on": ", 作成日時: ",
        "cancel": "キャンセル",
        "cd": "会心ダメージ",
        "clear": "クリア",
        "close": "閉じる",
        "combined": "合計",
        "config": "設定",
        "continue": "続ける",
        "copied_to_clipboard": "クリップボードにコピーしました",
        "copy": "コピー",
        "copy_link": "URLをコピー",
        "cr": "会心率",
        "create_a_shareable": "共有可能なリンクを取得",
        "damage_dealt_over": "時間経過による与ダメージの推移",
        "debug": "デバッグ",
        "debug_settings": "デバッグ設定",
        "defaults": "でフォルト",
        "defense": "防御力",
        "details": "詳細",
        "dps_by_ability": "天賦ごとのDPS (平均)",
        "em": "元素熟知",
        "er": "元素チャージ効率",
        "error_copying_not": "コピー失敗エラー :( 原因不明",
        "error_encountered": "エラー発生: ",
        "git_hash": "git hash: ",
        "hp": "HP",
        "level": "レベル",
        "link_is_permanent": "リンクは失効しません。 ",
        "link_post": "結果はこちらで確認可能です: ",
        "link_pre": "アップロード完了。",
        "link_will_expire": "リンクは7日間で失効します。 ",
        "load_this_configuration": "この設定を詳細モードで読み込みます。",
        "log_options": "ログ設定",
        "make_link_permanent": "リンクを永続化する",
        "note_that_by": "通常共有可能なリンクは7日間で失効します。これはサーバーの容量を適切に管理するためです。なおKo-Fiにて支援していただいた方はリンクを失効しないように設定できるAPIキーを取得できます。",
        "particles_count": "粒子の生成数",
        "please_note_that": "なおこの仕様は寄付を募るためのものではありません。制限されたサーバーの容量を適切に管理するための施策で、このプロジェクトを金銭的または寄付によってサポートしてくれた人々にささやかな感謝の意を示すものです。なおアクセスキーは私たちのDiscordサーバーにアクセスして取得することができます。",
        "reactions_triggered": "トリガーされた元素反応",
        "refinement": "精錬",
        "sec_post": "秒間の戦闘をシミュレート (",
        "sec_pre": "",
        "send_to_simulator": "シミュレーターに送る",
        "share": "共有",
        "substats": "サブオプション",
        "summary": "概要",
        "target": "ターゲット",
        "this_will_overwrite": "この操作は既存のシミュレーションデータを置き換えます。続行しますか？",
        "time_post": "秒かけて計算完了)",
        "time_pre": " 回の反復を ",
        "unknown": "不明",
        "upload": "アップロード",
        "upload_failed": "アップロード失敗"
    },
    "viewerdashboard": {
        "drag_n_drop": "読み込むにはzip化されたgcsimのJSONファイルをドラッグアンドドロップするかボタンをクリックしてアップロードしてください。",
        "drop_the_file": "ここにファイルをドロップ ...",
        "error_retrieving_specified": "指定されたURLを取得できませんでした",
        "or_select_from": "こちらから履歴を読み込む事もできます。（注意:再読み込みすると削除されます）",
        "upload_a_file": "ファイルをアップロード",
        "url_does_not": "このURLには読み込み可能なファイルが含まれていません。"
    },
    "weapon_names": {
        "akuoumaru": "惡王丸",
        "alleyhunter": "ダークアレイの狩人",
        "amenomakageuchi": "天目影打",
        "amosbow": "アモスの弓",
        "apprenticesnotes": "生徒ノート",
        "aquilafavonia": "風鷹剣",
        "beginnersprotector": "新米の長槍",
        "blackcliffagate": "黒岩の緋玉",
        "blackclifflongsword": "黒岩の長剣",
        "blackcliffpole": "黒岩の突槍",
        "blackcliffslasher": "黒岩の斬刀",
        "blackcliffwarbow": "黒岩の戦弓",
        "blacktassel": "黒纓槍",
        "bloodtaintedgreatsword": "龍血を浴びた剣",
        "calamityqueller": "息災",
        "cinnabarspindle": "シナバースピンドル",
        "compoundbow": "リングボウ",
        "coolsteel": "冷刃",
        "crescentpike": "流月の針",
        "darkironsword": "暗鉄剣",
        "deathmatch": "死闘の槍",
        "debateclub": "理屈責め",
        "dodocotales": "ドドコの物語",
        "dragonsbane": "匣中滅龍",
        "dragonspinespear": "ドラゴンスピア",
        "dullblade": "無鋒の剣",
        "elegyfortheend": "終焉を嘆く詩",
        "emeraldorb": "翡玉法珠",
        "engulfinglightning": "草薙の稲光",
        "everlastingmoonglow": "不滅の月華",
        "eyeofperception": "昭心",
        "favoniuscodex": "西風秘典",
        "favoniusgreatsword": "西風大剣",
        "favoniuslance": "西風長槍",
        "favoniussword": "西風剣",
        "favoniuswarbow": "西風猟弓",
        "ferrousshadow": "鉄影段平",
        "festeringdesire": "腐植の剣",
        "filletblade": "チ虎魚の刀",
        "freedomsworn": "蒼古なる自由への誓い",
        "frostbearer": "冬忍びの実",
        "hakushinring": "白辰の輪",
        "halberd": "鉾槍",
        "hamayumi": "破魔の弓",
        "harbingerofdawn": "黎明の神剣",
        "huntersbow": "狩猟弓",
        "ironpoint": "鉄尖槍",
        "ironsting": "鉄蜂の刺し",
        "kagurasverity": "神楽の真意",
        "katsuragikirinagamasa": "桂木斬長正",
        "kitaincrossspear": "喜多院十文字槍",
        "lionsroar": "匣中龍吟",
        "lithicblade": "千岩古剣",
        "lithicspear": "千岩長槍",
        "lostprayertothesacredwinds": "四風原典",
        "luxurioussealord": "銜玉の海皇",
        "magicguide": "魔導緒論",
        "mappamare": "万国諸海の図譜",
        "memoryofdust": "浮世の錠",
        "messenger": "文使い",
        "mistsplitterreforged": "霧切の廻光",
        "mitternachtswaltz": "幽夜のワルツ",
        "mouunsmoon": "曚雲の月",
        "oathsworneye": "誓いの明瞳",
        "oldmercspal": "傭兵の重剣",
        "otherworldlystory": "異世界旅行記",
        "pocketgrimoire": "ポケット魔導書",
        "polarstar": "冬極の白星",
        "predator": "プレデター",
        "primordialjadecutter": "磐岩結緑",
        "primordialjadewingedspear": "和璞鳶",
        "prototypeamber": "金珀·試作",
        "prototypearchaic": "古華·試作",
        "prototypecrescent": "澹月·試作",
        "prototyperancour": "斬岩·試作",
        "prototypestarglitter": "星鎌·試作",
        "rainslasher": "雨裁",
        "ravenbow": "鴉羽の弓",
        "recurvebow": "リカーブボウ",
        "redhornstonethresher": "赤角石塵滅砕",
        "royalbow": "旧貴族長弓",
        "royalgreatsword": "旧貴族大剣",
        "royalgrimoire": "旧貴族秘法録",
        "royallongsword": "旧貴族長剣",
        "royalspear": "旧貴族猟槍",
        "rust": "弓蔵",
        "sacrificialbow": "祭礼の弓",
        "sacrificialfragments": "祭礼の断片",
        "sacrificialgreatsword": "祭礼の大剣",
        "sacrificialsword": "祭礼の剣",
        "seasonedhuntersbow": "歴戦の狩猟弓",
        "serpentspine": "螭龍の剣",
        "sharpshootersoath": "シャープシューターの誓い",
        "silversword": "銀の剣",
        "skyridergreatsword": "飛天大御剣",
        "skyridersword": "飛天御剣",
        "skywardatlas": "天空の巻",
        "skywardblade": "天空の刃",
        "skywardharp": "天空の翼",
        "skywardpride": "天空の傲",
        "skywardspine": "天空の脊",
        "slingshot": "弾弓",
        "snowtombedstarsilver": "雪葬の星銀",
        "solarpearl": "匣中日月",
        "songofbrokenpines": "松韻の響く頃",
        "staffofhoma": "護摩の杖",
        "summitshaper": "斬山の刃",
        "swordofdescension": "降臨の剣",
        "thealleyflash": "ダークアレイの閃光",
        "thebell": "鐘の剣",
        "theblacksword": "黒剣",
        "thecatch": "「漁獲」",
        "theflute": "笛の剣",
        "thestringless": "絶弦",
        "theunforged": "無工の剣",
        "theviridescenthunt": "蒼翠の狩猟弓",
        "thewidsith": "流浪楽章",
        "thrillingtalesofdragonslayers": "龍殺しの英傑譚",
        "thunderingpulse": "飛雷の鳴弦",
        "travelershandysword": "旅道の剣",
        "twinnephrite": "特級の宝玉",
        "vortexvanquisher": "破天の槍",
        "wastergreatsword": "訓練用大剣",
        "wavebreakersfin": "斬波のひれ長",
        "whiteblind": "白影の剣",
        "whiteirongreatsword": "白鉄の大剣",
        "whitetassel": "白纓槍",
        "windblumeode": "風花の頌歌",
        "wineandsong": "ダークアレイの酒と詩",
        "wolfsgravestone": "狼の末路"
    }
}